"use client";

import LABELS from "@/components/global-constant/src/general";

export default function PromotionalHeader() {
  return (
    <div className="bg-black text-white text-xs font-light py-2 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4">
        <div className="w-full overflow-hidden whitespace-nowrap">
          <p className="animate-marquee inline-block min-w-full text-center uppercase">
            {LABELS.PROMOTIONAL_HEADER_MSG}
          </p>
        </div>
      </div>
    </div>
  );
}
